export function nonNegativeNumberValidation(errorMessage) {
    return (value)=>{
        if (!value.trim() || Number.isNaN(+value) || +value < 0) {
            return errorMessage || false;
        }
        return true;
    };
}
